import gql from 'graphql-tag'

const statsClassificaAppuntamentiProposte = gql`
  query statsClassificaAppuntamentiProposte($range: Range!, $type: ClassificaType!) {
    statsClassificaAppuntamentiProposteAgenti(range: $range, type: $type) {
      nome
      count
    }
  }
`

export default statsClassificaAppuntamentiProposte



// WEBPACK FOOTER //
// ./src/graphql/queries/statsClassificaAppuntamentiProposte.js